import {Component, OnInit, ViewChild} from '@angular/core';
import {AuthService} from '../services/auth/auth.service';
import {HttpService} from '../services/http/http.service';
import searchboxdata from '../../assets/searchboxdata.json';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {concat, forkJoin} from 'rxjs';
import {toArray} from 'rxjs/operators';
import {AssociazioniDialog} from "../dialog/associazioni-dialog/associazioni-dialog.component";
import {AssembleaApprovazioneDialog} from "../dialog/assemblea-approvazione/assemblea-approvazione.component";
import {AssembleaDecretazioneDialog} from "../dialog/assemblea-decretazione/assemblea-decretazione.component";
import {DetailsDialog} from "../dialog/details-dialog/details-dialog.component";
import {SediDialog} from "../dialog/sedi-dialog/sedi-dialog.component";
import {ConfirmDialog} from "../dialog/confirm-dialog/confirm-dialog.component";
import {CaricaDocumentoDialog} from "../dialog/carica-documento-dialog/carica-documento-dialog.component";
import {
  CaricaNuovoDocumentoDialog
} from "../dialog/carica-nuovo-documento-dialog/carica-nuovo-documento-dialog.component";
import {ListaAssociazioniDialog} from "../dialog/lista-associazioni-dialog/lista-associazioni-dialog.component";
import {
  DetailsAbilitaConoscenzeDialog
} from "../dialog/details-abilita-conoscenze-dialog/details-abilita-conoscenze-dialog.component";
import {
  ModificaPropostaCompetenzaDialog
} from "../dialog/modifica-proposta-competenza-dialog/modifica-proposta-competenza-dialog.component";
import {
  DetailsPropostaCompetenzaDialog
} from "../dialog/details-proposta-competenza-dialog/details-proposta-competenza-dialog.component";
import {
  DetailsPropostaProfiloProfessionaleDialog
} from "../dialog/details-proposta-profilo-professionale-dialog/details-proposta-profilo-professionale-dialog.component";
import {ClassificazioniDialog} from "../dialog/classificazioni-dialog/classificazioni-dialog.component";
import {ConoscenzeAbilitaDialog} from "../dialog/conoscenze-abilita-dialog/conoscenze-abilita-dialog.component";
import {NotificationDialogComponent} from "../dialog/notification-dialog/notification-dialog.component";
import {RifiutaProfiloComponent} from "../dialog/rifiuta-profilo/rifiuta-profilo.component";
import { EliminaProfiloComponent } from '../dialog/elimina-profilo/elimina-profilo.component';
import {BooleanoView, UserLoginView, BasicResponse, DizionarioView} from "@model";
import {COMPETENCES_ASSOCIATED_SUCCESSFULLY} from "@constants";
import { SearchboxComponent } from '../searchbox/searchbox.component';
import { EliminaCompetenzaComponent } from '../dialog/elimina-competenza/elimina-competenza.component';
import { RifiutaCompetenzaComponent } from '../dialog/rifiuta-competenza/rifiuta-competenza.component';
import { DetailsAreaDialog } from '../dialog/details-area-dialog/details-area-dialog.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  @ViewChild(SearchboxComponent) searchbox!: SearchboxComponent;
  pageIndex: number = 0;
  pageSize: number = 10;
  isAssistenza: boolean = true;
  hasPermission: boolean = false;
  savedEvent: any;
  buttonText: string;
  detailsData: any;
  menuItems: any;
  contentTitle: any;
  boxSearchData: any;
  sectionName: any;
  tableData: any = undefined;
  showSearchBox: boolean = false;
  boxContent: any = searchboxdata.list;
  paginatorSize: any;
  cols: string[];
  breadLinks: any = {
    'firstLink': {
      'name': 'Home',
      'link': '/'
    },
    'secondLink': {
      'name': 'Profili',
      'link': '/secured/landing'
    },
    'thirdLink': {
      'name': '',
      'link': ''
    }
  }

  constructor(
    private readonly auth: AuthService,
    private readonly api: HttpService,
    public dialog: MatDialog,
    private readonly snackBar: MatSnackBar) {
  }

  ngOnInit(): void {
    this.auth.authLogin().subscribe({
      next: (response: BasicResponse<UserLoginView>) => {
        this.menuItems = response.result.listaFunzionaliita;
        this.contentTitle = this.menuItems ? this.menuItems[0].descrizione : '';
        if (this.menuItems) {
          let currentPage = sessionStorage.getItem('currentPage') ? JSON.parse(sessionStorage.getItem('currentPage') ?? '{}') : this.menuItems[0];
          this.sectionName = this.boxContent.find((item: any) => (item.id == currentPage.id)).name;
          this.boxSearchData = this.boxContent.find((item: any) => (item.id == currentPage.id)).data;
        }
        this.loadContent();
      }
    })
  }

  // SET SEARCHBOX SELECT OPTIONS AND TITLE
  setCombo(response: BasicResponse<DizionarioView[]>, index: number) {
    this.boxSearchData[index].options = response.result;
    this.contentTitle ??= this.menuItems[0].descrizione;
    this.showSearchBox = true;
  }

  //FUNZIONI PER CARICAMENTO SELECT SEARCHBOX
  compareId(a: any, b: any) {
    if (a.id < b.id) {
      return -1;
    }

    if (a.id > b.id) {
      return 1;
    }

    return 0;
  }

  profiloAttivo(index: any) {
    this.api.getTAreaProfiloAttivo().subscribe({
      next: (response: any) => {
        response.result.sort(this.compareId)
        this.setCombo(response, index);
      }
    })
  }

  profilo(index: any) { // da deprecare in ambiente autenticato, sostituire con profiloAttivo()
    this.api.getTAreaProfilo().subscribe({
      next: (response: any) => {
        response.result.sort(this.compareId)
        this.setCombo(response, index);
      }
    })
  }

  tipologiaCompetenza(index: any) {
    this.api.getTipologiaCompetenza().subscribe({
      next: (response: BasicResponse<DizionarioView[]>) => {
        this.setCombo(response, index);
      }
    })
  }

  sottoCategoriaCompetenzaBase(index: number) {
    this.api.getTipologiaCategoriaBase()
      .subscribe({
        next: (response: BasicResponse<DizionarioView[]>) => {
          this.setCombo(response, index);
        }
      })
  }

  sottoCategoriaCompetenzaDigitale(index: number) {
    this.api.getTipologiaCategoriaDigitale()
      .subscribe({
        next: (response: BasicResponse<DizionarioView[]>) => {
          this.setCombo(response, index);
        }
      })
  };

  statoPropostaPerElenco(index: number) {
    this.api.getStatoPropostaPerElenco().subscribe({
      next: (response: BasicResponse<DizionarioView[]>) => {
        this.setCombo(response, index);
      }
    })
  }

  statiCompetenzaPerFunzioneElenco(index: number) {
    this.api.getStatiCompetenzaPerFunzioneElenco().subscribe({
      next: (response: BasicResponse<DizionarioView[]>) => {
        this.setCombo(response, index);
      }
    })
  }

  statoPropostaPerArchivio(index: number) {
    this.api.getStatoPropostaPerArchivio().subscribe({
      next: (response: BasicResponse<DizionarioView[]>) => {
        this.setCombo(response, index);
      }
    })
  }

  statoCompetenzePerArchivio(index: number) {
    this.api.getStatoCompetenzaPerArchivio().subscribe({
      next: (response: BasicResponse<DizionarioView[]>) => {
        this.setCombo(response, index);
      }
    })
  }

  tipologie(index: number) {
    this.api.getTipologie().subscribe({
      next: (response: BasicResponse<DizionarioView[]>) => {
        this.setCombo(response, index);
      }
    })
  }

  stati(index: number) {
    this.api.getTipoStati().subscribe({
      next: (response: BasicResponse<DizionarioView[]>) => {
        this.setCombo(response, index);
      }
    })
  }

  decreti(index: any) {
    this.api.getTipoAreaCaricamento().subscribe({
      next: (response: BasicResponse<DizionarioView[]>) => {
        this.setCombo(response, index);
      }
    })
  }

  allegati(index: number) {
    this.api.getTipologieAllegato().subscribe({
      next: (response: BasicResponse<DizionarioView[]>) => {
        this.setCombo(response, index);
      }
    })
  }

  statiAssemblea(index: number) {
    this.api.getStatiAssemblea().subscribe({
      next: (response: BasicResponse<DizionarioView[]>) => {
        this.setCombo(response, index);
      }
    })
  }

  opzioniAree() {
    this.api.getAreeSep().subscribe({
      next: (response: BasicResponse<DizionarioView[]>) => {
        this.setCombo(response, 0);
      }
    })
    this.api.getStatiAree().subscribe({
      next: (response: BasicResponse<DizionarioView[]>) => {
        this.setCombo(response, 2);
      }
    })
  }

  // FINE FUNZIONI PER CARICAMENTO SELECT SEARCHBOX

  loadContent() {
    this.auth.isUtenteAssistenza().subscribe({
      next: (response: any) => {
        this.isAssistenza = response.result.booleano;
        this.hasPermission = !this.isAssistenza;
      }
    })
    const event = sessionStorage.getItem('currentPage') ? JSON.parse(sessionStorage.getItem('currentPage') ?? '') : this.menuItems[0];

    this.tableData = undefined;
    this.buttonText = '';
    this.sectionName = this.boxContent.find((item: any) => (item.id == event.id)).name;
    this.boxSearchData = this.boxContent.find((item: any) => (item.id == event.id)).data;
    this.breadLinks.thirdLink.name = this.boxContent.find((item: any) => (item.id == event.id)).breadCrumb;
    switch (this.sectionName) {
      case "gestioneProfiloProfessionale": {
        this.profiloAttivo(0);
        this.buttonText = 'Nuovo profilo professionale';
        break;
      }

      case "gestioneCompetenze" : {
        this.profiloAttivo(1);
        this.tipologiaCompetenza(0)
        this.sottoCategoriaCompetenzaBase(2);
        this.sottoCategoriaCompetenzaDigitale(4);
        this.buttonText = 'Nuova competenza';
        break;
      }

      case "elencoProposteProfiloProfessionale": {
        this.profiloAttivo(0);
        this.statoPropostaPerElenco(2);
        break;
      }

      case "elencoProposteCompetenze": {
        this.tipologiaCompetenza(0);
        this.sottoCategoriaCompetenzaBase(2);
        this.sottoCategoriaCompetenzaDigitale(5);
        this.profiloAttivo(1);
        this.statiCompetenzaPerFunzioneElenco(4);
        break;
      }

      case "archivioProposteProfiloProfessionale": {
        this.profiloAttivo(0);
        this.statoPropostaPerArchivio(2)
        break;
      }

      case "archivioProposteCompetenze": {
        this.tipologiaCompetenza(0);
        this.profiloAttivo(1);
        this.statoCompetenzePerArchivio(3);
        this.sottoCategoriaCompetenzaBase(6);
        this.sottoCategoriaCompetenzaDigitale(7);
        break;
      }

      case "archivioAbilitaConoscenze": {
        this.tipologie(0);
        this.stati(2)
        break;
      }

      case "gestioneAssemblea": {
        this.buttonText = 'Nuova assemblea';
        this.showSearchBox = true;
        this.statiAssemblea(2);
        break;
      }

      case "gestioneUtenze": {
        this.buttonText = 'Nuovo utente';
        this.showSearchBox = true;
        break;
      }

      case "gestioneOperatori": {
        this.buttonText = 'Nuovo operatore';
        this.showSearchBox = true;
        break;
      }

      case "caricaDocumenti": {
        this.decreti(0);
        break;
      }

      case "creaAllegati": {
        this.allegati(0);
        break;
      }
      case "gestioneAree": {
        this.buttonText = 'Nuova Area';
        this.showSearchBox = true;
        this.opzioniAree();
        break;
      }

      default: {
        this.contentTitle ??= this.menuItems[0].descrizione;
        this.showSearchBox = true;
        break;
      }
    }

    this.contentTitle = event.descrizione;
    if (this.searchbox) {
      this.searchbox.reset(); //  Ripristina dopo cambio menu
    }
  }

  paginationLoad(data: any) {

    this.pageIndex = data.index;
    this.pageSize = data.pageSize;
    this.savedEvent.isSearch = false;
    this.loadTable(this.savedEvent);
  }

  loadTable(event: any) {
    if (event?.isSearch) {
      this.pageIndex = 0;
    }

    this.savedEvent = { ...event };
    const currentSearchSection = this.savedEvent.name;
    this.tableData = null;

    let data: any = {};
    if (event.value?.area?.id && !event.value?.tipologia) {
      data.tipoAreaProfilo = {
        "id": event.value.area.id,
        "descrizione": event.value.area.descrizione,
        "ordinamento": null
      }
    }

    if (event.value?.tipologia) {
      data.tipologia = {
        "id": event.value.tipologia.id,
        "descrizione": event.value.tipologia.descrizione,
        "codiceAda": null
      }

      if (event.value?.area?.id) {
        data.tipoArea = {
          "id": event.value.area.id,
          "descrizione": event.value.area.descrizione,
          "codiceAda": null
        }
      }
    }

    if (event.value?.descrizione) {
      data.descrizione = event.value.descrizione
    }

    if (event.value?.statoConoscenza) {
      data.statoConoscenza = event.value.statoConoscenza
    }

    if (event.value?.dataRiunione) {
      let day = event.value.dataRiunione.getDate();
      day = (day < 10) ? "0" + day : day;
      let month = event.value.dataRiunione.getMonth() + 1;
      month = (month < 10) ? "0" + month : month;
      let year = event.value.dataRiunione.getFullYear();
      data.dataRiunione = year + '-' + month + '-' + day;
    }

    if (event.value?.dataApprovazione) {
      let day = event.value.dataApprovazione.getDate();
      day = (day < 10) ? "0" + day : day;
      let month = event.value.dataApprovazione.getMonth() + 1;
      month = (month < 10) ? "0" + month : month;
      let year = event.value.dataApprovazione.getFullYear();
      data.dataApprovazione = year + '-' + month + '-' + day;
    }

    if (event.value?.nomeUtente) {
      data.nomeUtente = event.value.nomeUtente;
    }

    if (event.value?.cognomeUtente) {
      data.cognomeUtente = event.value.cognomeUtente;
    }

    if (event.value?.codiceFiscale) {
      data.codiceFiscale = event.value.codiceFiscale;
    }

    if (event.value?.statoCompetenza) {
      data.statoCompetenza = event.value.statoCompetenza;
    }

    if (event.value?.statoProposta) {
      data.statoProposta = event.value.statoProposta;
    }

    if (event.value?.statoAssemblea) {
      data.statoAssemblea = event.value.statoAssemblea;
    }

    if (event.value?.sottoCategoria) {
      data.sottoCategoria = event.value.sottoCategoria;
    }

    if (event.value?.stato) {
      data.stato = event.value.stato;
    }

    if (event.value?.areaSep) {
      data.areaSep = event.value.areaSep;
    }

    if (event.value?.statoArea) {
      data.statoArea = event.value.statoArea;
    }

  if (this.sectionName === "archivioProposteProfiloProfessionale" || this.sectionName==="archivioProposteCompetenze") {
      data.hasDigitalCompetence = event.hasDigitalCompetence;
      data.hasGreenCompetence = event.hasGreenCompetence;

    }

    switch (currentSearchSection) {
      case "gestioneProfiloProfessionale": {
        this.api.ricercaProfili(data, this.pageIndex, this.pageSize).subscribe({
          next: (response: any) => {
            this.paginatorSize = response.result.count;
            this.tableData = response.result.listaProfili;
            this.cols = ['area', 'profilo', 'stato_proposta', 'azioni']
          },
          complete: () => {
            if (event.isSearch && this.searchbox) {
             // this.searchbox.reset();
            }
          }
        })
        break;
      }

      case "gestioneCompetenze": {
        this.api.ricercaCompetenze(data, this.pageIndex, this.pageSize).subscribe({
          next: (response: any) => {
            this.paginatorSize = response.result.count;
            this.tableData = response.result.listaCompetenze;
            this.cols = ['tipologia', 'descrizione', 'stato_competenza', 'azioni']
          },
          complete: () => {
            if (event.isSearch && this.searchbox) {
              //this.searchbox.reset();
            }
          }
        })
        break;
      }

      case "elencoProposteProfiloProfessionale": {
        this.api.ricercaProfiliRegione(data, this.pageIndex, this.pageSize).subscribe({
          next: (response: any) => {
            this.paginatorSize = response.result.count;
            this.tableData = response.result.listaProfili;
            this.cols = ['area', 'codice_profilo', 'profilo', 'stato_profilo', 'azioni']
          },
          complete: () => {
            if (event.isSearch && this.searchbox) {
              //this.searchbox.reset();
            }
          }
        })
        break;
      }

      case "elencoProposteCompetenze": {
        this.api.ricercaCompetenzeRegione(data, this.pageIndex, this.pageSize).subscribe({
          next: (response: any) => {
            this.paginatorSize = response.result.count;
            this.tableData = response.result.listaCompetenze;
            this.cols = ['tipologia', 'competenza', 'stato_proposta', 'azioni']
          },
          complete: () => {
            if (event.isSearch && this.searchbox) {
              //this.searchbox.reset();
            }
          }
        })
        break;
      }

      case "archivioProposteProfiloProfessionale": {
        this.api.ricercaArchivioProposte(data, this.pageIndex, this.pageSize).subscribe({
          next: (response: any) => {
            this.paginatorSize = response.result.count;
            this.tableData = response.result.listaArchivioProfilo;
            this.cols = ['area', 'codice_profilo', 'profilo', 'stato_proposta', 'azioni']
          },
          complete: () => {
            if (event.isSearch && this.searchbox) {
              //this.searchbox.reset();
            }
          }
        })
        break;
      }

      case "archivioProposteCompetenze": {
        this.api.ricercaArchivioCompetenze(data, this.pageIndex, this.pageSize).subscribe({
          next: (response: any) => {
            this.paginatorSize = response.result.count;
            this.tableData = response.result.listaArchivioCompetenze;
            this.cols = ['tipologia', 'competenza', 'stato_proposta', 'azioni']
          },
          complete: () => {
            if (event.isSearch && this.searchbox) {
              //this.searchbox.reset();
            }
          }
        })
        break;
      }

      case "archivioAbilitaConoscenze": {
        data.page = this.pageIndex;
        data.size = this.pageSize;

        this.api.ricercaAbilitaConoscenze(data).subscribe({
          next: (response: any) => {
            this.paginatorSize = response.result.count;
            this.tableData = response.result.lista;
            this.cols = ['tipologia', 'descrizione', 'stato', 'azioni']
          },
          complete: () => {
            if (event.isSearch && this.searchbox) {
              //this.searchbox.reset();
            }
          }
        })
        break;
      }

      case "caricaDocumenti": {
        this.api.getDocumenti(data.tipoAreaProfilo.id, this.pageIndex, this.pageSize).subscribe({
          next: (response: any) => {
            this.paginatorSize = response.result.count;
            this.tableData = response.result.listaDocumenti;
            this.cols = ['posizione', 'descrizione', 'azioni']
          },
          complete: () => {
            if (event.isSearch && this.searchbox) {
              //this.searchbox.reset();
            }
          }
        })
        break;
      }

      case "gestioneAssemblea": {
        this.api.ricercaAssemblea(data, this.pageIndex, this.pageSize).subscribe({
          next: (response: any) => {
            this.paginatorSize = response.result.count;
            this.tableData = response.result.listaAssemblea;
            this.cols = ['data_riunione', 'data_approvazione', 'descrizione', 'stato', 'azioni']
          },
          complete: () => {
            if (event.isSearch && this.searchbox) {
              //this.searchbox.reset();
            }
          }
        })
        break;
      }

      case "gestioneUtenze": {
        data.codiceFiscale ??= "";
        data.cognomeUtente ??= "";
        data.nomeUtente ??= "";

        this.api.ricercaUtenti(data, this.pageIndex, this.pageSize).subscribe({
          next: (response: any) => {
            this.paginatorSize = response.result.count;
            this.tableData = response.result.listaUtenti;
            this.cols = ['cf', 'nome', 'cognome', 'attivo', 'azioni']
          },
          complete: () => {
            if (event.isSearch && this.searchbox) {
             // this.searchbox.reset();
            }
          }
        })
        break;
      }

      case "gestioneOperatori": {
        data.descrizione ??= "";
        this.api.ricercaOperatori(data, this.pageIndex, this.pageSize).subscribe({
          next: (response: any) => {
            this.paginatorSize = response.result.count;
            this.tableData = response.result.listaOperatori;
            this.cols = ['nome_operatore', 'attivo', 'azioni']
          },
          complete: () => {
            if (event.isSearch && this.searchbox) {
             // this.searchbox.reset();
            }
          }
        })
        break;
      }

      case "gestioneAree": {
        data.descrizione ??= "";
        this.api.ricercaAree(data, this.pageIndex, this.pageSize).subscribe({
          next: (response: any) => {
            this.paginatorSize = response.result.count; 
            this.tableData = response.result.aree;
            this.cols = ['id_area', 'descrizione', 'area_sep', 'stato_area', 'azioni']
          },
          complete: () => {
            if (event.isSearch && this.searchbox) { 
            }
          }
        })
        break;
      }


      default: {
        //statements;
        break;
      }
    }


  }

  // GESTIONE EVENTI CLICK TABELLE
  // EVENTO CLICK DETTAGLIO
  detailEvent(event: any) {
    if (this.sectionName == 'gestioneProfiloProfessionale') {
      this.api.getProfilo(event.element.idProposta).subscribe({
        next: (response: any) => {
          this.detailsData = response.result;
          if (this.detailsData) {
            this.openDialog('edit')
          }

        }
      })
    }

    if (this.sectionName == 'gestioneCompetenze') {
      this.api.getCompetenza(event.element.id).subscribe({
        next: (response: any) => {
          this.detailsData = response.result;
          if (this.detailsData) {
            this.openDialog('edit')
          }
        }
      })
    }

    if (this.sectionName == 'elencoProposteCompetenze' || this.sectionName == 'archivioProposteCompetenze') {


      this.api.getCompetenzaDettaglio(event.element.id).subscribe({
        next: (res: any) => {
          this.openDettaglioPropostaDialog(res.result, false)
        }
      })
    }

    if (this.sectionName == 'elencoProposteProfiloProfessionale' || this.sectionName == 'archivioProposteProfiloProfessionale') {


      this.api.getProfiloDettaglio(event.element.idProposta).subscribe({
        next: (res: any) => {
          this.openDettaglioPropostaProfiloProfessionaleDialog(res.result, false)
        }
      })
    }

    if (this.sectionName == 'gestioneAssemblea') {
      this.api.getAssemblea(event.element.id).subscribe({
        next: (response: any) => {
          this.detailsData = response.result;
          if (this.detailsData) {
            this.openDialog('edit')
          }
        }
      })
    }

    if (this.sectionName == 'gestioneUtenze') {


      this.api.caricaUtente(event.element.codiceFiscale).subscribe({
        next: (response: any) => {

          this.detailsData = response.result;
          if (this.detailsData) {
            this.openDialog('edit')
          }
        }
      })
    }

    if (this.sectionName == 'gestioneOperatori') {
      this.api.caricaOperatore(event.element.id).subscribe({
        next: (response: any) => {
          this.detailsData = response.result;
          if (this.detailsData) {
            this.openDialog('edit')
          }
        }
      })
    }


  }

  detailCompetenzaEvent(event: any) {
    this.api.getCompetenzaDettaglio(event.element.id).subscribe({
      next: (res: any) => {
        this.openDettaglioPropostaDialog(res.result, true)
      }
    })
  }

  modificaCompetenzaEvent(event: any) {
    this.api.modificaCompetenza(event.element.id).subscribe({
      next: (res: any) => {
        this.openModificaPropostaDialog(res.result, true)
      }
    })
  }


  detailAbilitaConoscenze(event: any) {
    this.api.ricercaCompetenzeArchivio(event.element.tipologia.id, event.element.id).subscribe({
      next: (res: any) => {
        this.openDettaglioAbilitaConoscenze(res.result, event)
      }
    })

  }


  validaCompetenzaEvent(event: any) {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {title: "Valida competenza", text: "Vuoi validare la competenza?"}
    });


    dialogRef.afterClosed().subscribe((result: any) => {


      if (result.confirm) {
        this.api.validaCompetenza({valore: event.element.id}).subscribe({
          next: () => {
            this.loadTable(this.savedEvent);
            this.snackBar.open('Competenza validata', 'close', {panelClass: 'successSnack'});
          }
        })
      }
    })
  }

  rifiutaCompetenzaEvent(event: any) {
    const dialogRef = this.dialog.open(RifiutaCompetenzaComponent, {
      data: { idCompetenza: event.element.id },
    });
    dialogRef.afterClosed().subscribe((refreshData: boolean) => {
      if (refreshData) {
        this.loadTable(this.savedEvent);
      }
    });
  }


  detailProfiloEvent(event: any) {
    this.api.getProfiloDettaglio(event.element.idProposta).subscribe({
      next: (res: any) => {
        this.openDettaglioPropostaProfiloProfessionaleDialog(res.result, true)
      }
    })
  }


  validaProfiloEvent(event: any) {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {title: "Valida profilo", text: "Vuoi validare il profilo?"}
    });


    dialogRef.afterClosed().subscribe((result: any) => {


      if (result.confirm) {
        this.api.validaProfilo({valore: event.element.idProposta}).subscribe({
          next: () => {
            this.loadTable(this.savedEvent);
            this.snackBar.open('Profilo validato', 'close', {panelClass: 'successSnack'});
          }
        })
      }
    })
  }


  rifiutaProfiloEvent(event: any) {
    const dialogRef = this.dialog.open(RifiutaProfiloComponent, {
      data: {idProfilo : event.element.idProfilo, idProposta : event.element.idProposta}
    });


    dialogRef.afterClosed().subscribe((refreshData: boolean) => {
      if(refreshData){
        this.loadTable(this.savedEvent)
      }
    })
  }

  disabilitaUtenteEvent(event: any) {

    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {title: "Disabilita utente", text: "Vuoi disabilitare l'utente?"}
    });


    dialogRef.afterClosed().subscribe((result: any) => {


      if (result.confirm) {
        this.api.disableUtente(event.element.idPersona).subscribe({
          next: () => {
            this.loadTable(this.savedEvent);
            this.dialog.open(NotificationDialogComponent, {
              data: {
                title: "Disabilitazione Utente",
                message: "Disabilitazione avvenuta con successo, per riattivare l'utente visualizzare il relativo dettaglio della pagina di ricerca ed eseguire nuovamente il salvataggio."
              }
            })
          }
        })
      }
    })
  }

  abilitaUtenteEvent(event: any) {

    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {title: "Abilita utente", text: "Vuoi abilitare l'utente?"}
    });


    dialogRef.afterClosed().subscribe((result: any) => {


      if (result.confirm) {
        this.api.abilitaUtente(event.element.idPersona).subscribe({
          next: () => {
            this.loadTable(this.savedEvent);
            this.dialog.open(NotificationDialogComponent, {
              data: {
                title: "Abilitazione Utente",
                message: "Abilitazione avvenuta con successo."
              }
            })
          }
        })
      }
    })
  }

  abilitaOperatoreEvent(event: any) {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {title: "Abilita operatore", text: "Vuoi abilitare l'operatore?"}
    });


    dialogRef.afterClosed().subscribe((result: any) => {


      if (result.confirm) {
        this.api.abilitaOperatore(event.element.id).subscribe({
          next: () => {
            this.loadTable(this.savedEvent);
            this.snackBar.open('Operatore abilitato', 'close', {panelClass: 'successSnack'});
          }
        })
      }
    })
  }

  disabilitaOperatoreEvent(event: any) {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {title: "Disabilita operatore", text: "Vuoi disabilitare l'operatore?"}
    });


    dialogRef.afterClosed().subscribe((result: any) => {


      if (result.confirm) {
        this.api.disabilitaOperatore(event.element.id).subscribe({
          next: () => {
            this.loadTable(this.savedEvent);
            this.snackBar.open('Operatore disabilitato', 'close', {panelClass: 'successSnack'});
          }
        })
      }
    })
  }

  // EVENTO CLICK ASSOCIA COMPETENZE
  competenzeEvent(event: any) {

    concat(
      this.api.getCompetenzeByIdProposta(event.element.idProposta),
      this.api.getRicercaCompetenzeDaAssociare({}, 0, 25)
    ).pipe(
      toArray(),
    ).subscribe({
      next: (response: any) => {


        let competenzeProposta = response[0].result;
        let listaCompetenze = response[1].result.listaCompetenze
        // filtro per non far apparire nella lista competenze le competenze già associate
        let filteredLista = listaCompetenze.filter(function (o1: { id: any; }) {
          // filter out (!) items in result2
          return !competenzeProposta.some(function (o2: { id: any; }) {
            return o1.id === o2.id;          // assumes unique id
          });
        })

        this.openAssociaCompetenzeDialog(competenzeProposta, filteredLista, event.element.idProposta, response[1].result.count, event.element.descrizioneArea.descrizione, event.element.nomeProfilo, 'competenze');
      }
    });

  }


  // EVENTO CLICK ASSOCIA COMPETENZE ASSEMBLEA
  competenzeAssembleaEvent(event: any) {


    concat(
      this.api.getCompetenzeAssegnateAssemblea(event.element.id),
      this.api.ricercaCompetenzeValidate({}, 0, 25)
    ).pipe(
      toArray(),
    ).subscribe({
      next: (response: any) => {


        let competenzeProposta = response[0].result;
        let listaCompetenze = response[1].result.listaCompetenze
        // filtro per non far apparire nella lista competenze le competenze già associate
        let filteredLista = listaCompetenze.filter(function (o1: { id: any; }) {
          // filter out (!) items in result2
          return !competenzeProposta.some(function (o2: { id: any; }) {
            return o1.id === o2.id;          // assumes unique id
          });
        })

        this.openAssociaCompetenzeDialog(competenzeProposta, filteredLista, event.element.id, response[1].result.count, event.element.descrizione, event.element.nomeDecreto, 'competenze');
      }
    });

  }

  // EVENTO CLICK ASSOCIA PROFILI PROFESSIONALI ASSEMBLEA
  editAssociazioneProfiliAssembleaEvent(event: any) {


    concat(
      this.api.getProfiliAssegnati(event.element.id),
      this.api.ricercaProfiliValidati({}, 0, 25)
    ).pipe(
      toArray(),
    ).subscribe({
      next: (response: any) => {


        let profiliProposta = response[0].result;
        let listaProfili = response[1].result.listaProfili
        // filtro per non far apparire nella lista competenze le competenze già associate
        let filteredLista = listaProfili.filter(function (o1: { idProposta: any; }) {
          // filter out (!) items in result2
          return !profiliProposta.some(function (o2: { idProposta: any; }) {
            return o1.idProposta === o2.idProposta;          // assumes unique id
          });
        })

        this.openAssociaCompetenzeDialog(profiliProposta, filteredLista, event.element.id, response[1].result.count, event.element.descrizione, event.element.nomeDecreto, 'profili');
      }
    });

  }

  // EVENTO CLICK ASSOCIA CONOSCENZE
  conoscenzeEvent(event: any) {
    this.api.getAssociazioniConoscenze(event.element.id, null, 0, 25)
      .subscribe((response: any) => {
        const data: any = response.result;
        const conoscenzeAssociate = data.conoscenzeAssociate;
        const conoscenzeAssociabili = data.conoscenzeAssociabili;
        const conoscenzeAssociabiliTotalCount = data.conoscenzeAssociabiliTotalCount;
        this.openAssociaCompetenzeDialog(conoscenzeAssociate, conoscenzeAssociabili, event.element.id, conoscenzeAssociabiliTotalCount, event.element.descrizione, '', 'conoscenze');

      })
  }

  // EVENTO CLICK ASSOCIA ABILITA
  abilitaEvent(event: any) {
    concat(
      this.api.getAbilitaByCompetenza(event.element.id),
      this.api.ricercaAbilita({}, 0, 25)
    ).pipe(
      toArray(),
    ).subscribe({
      next: (response: any) => {


        let abilitaProposta = response[0].result;
        let listaAbilita = response[1].result.listaAbilita
        // filtro per non far apparire nella lista competenze le competenze già associate
        let filteredLista = listaAbilita.filter(function (o1: { id: any; }) {
          return !abilitaProposta.some(function (o2: { id: any; }) {
            return o1.id === o2.id;          // assumes unique id
          });
        })

        this.openAssociaCompetenzeDialog(abilitaProposta, filteredLista, event.element.id, response[1].result.count, event.element.descrizione, '', 'abilita');
      }
    });

  }

  // EVENTO CLICK ASSOCIA CLASSIFICAZIONI
  classificazioniEvent(event: any) {


    this.openClassificazioniDialog(event)
  }


  archiviaCompetenzaEvent(event: any) {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {title: "Archivia competenza", text: "Vuoi archiviare la competenza?"}
    });


    dialogRef.afterClosed().subscribe((result: any) => {


      if (result.confirm) {

        this.api.archiviaCompetenza({'valore': event.element.id}).subscribe({
          next: (response: any) => {

            if (response.operation != 3) {
              this.loadTable(this.savedEvent);
              this.snackBar.open('Competenza archiviata correttamente', 'close', {panelClass: 'successSnack'});
            }
          }
        })
      }
    })
  }

  archiviaPropostaEvent(event: any) {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {title: "Archivia proposta", text: "Vuoi archiviare la proposta?"}
    });


    dialogRef.afterClosed().subscribe((result: any) => {


      if (result.confirm) {

        this.api.archiviaProposta({'valore': event.element.idProposta}).subscribe({
          next: (response: any) => {

            if (response.operation != 3) {
              this.loadTable(this.savedEvent);
              this.snackBar.open('Proposta archiviata correttamente', 'close', {panelClass: 'successSnack'});
            }
          }
        })
      }
    })
  }

  duplicaProfiloEvent(event: any) {


    this.api.duplicaProfilo(event.element.idProposta).subscribe({
      next: (response: any) => {
        this.detailsData = response.result;
        if (this.detailsData) {
          this.openDialog('duplica_profilo')
        }
      }
    })
  }

  sostituisciDoc(event: any) {


    this.api.getDocumento(event.element.idAllegato, event.element.idAreaCaricamento).subscribe({
      next: (response: any) => {
        this.detailsData = response.result;
        if (this.detailsData) {
          this.openDialogCaricaDocumenti(event.element.idAreaCaricamento);
        }
      }
    })
  }

  openDialogCaricaDocumenti(idAreaCaricamento: any) {
    this.detailsData.idAreaCaricamento = idAreaCaricamento;
    const dialogRef = this.dialog.open(CaricaDocumentoDialog, {
      data: {details: this.detailsData},

    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.loadTable(this.savedEvent);
      }
    })
  }

  openDialogNewCaricaDocumenti() {
    const dialogRef = this.dialog.open(CaricaNuovoDocumentoDialog, {
      data: {details: this.detailsData},

    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.loadTable(this.savedEvent);
      }
    })
  }

  // EVENTO CLICK ELIMINA
  eliminaEvent(event: any) {
    
    if (this.sectionName == "gestioneProfiloProfessionale") {
    const dialogRef = this.dialog.open(EliminaProfiloComponent, {
      data: {idProposta : event.element.idProposta}
    });
    dialogRef.afterClosed().subscribe((refreshData: boolean) => {
      if(refreshData){
        this.loadTable(this.savedEvent)
      }
    })
  } else if (this.sectionName == "gestioneCompetenze") {
      const dialogRef = this.dialog.open(EliminaCompetenzaComponent, {
        data: {idCompetenza: event.element.id}
      });
      dialogRef.afterClosed().subscribe((refreshData: boolean) => {
      if(refreshData){
        this.loadTable(this.savedEvent)
      }
    })
    }
  }

  // EVENTO CLICK ELIMINA DOC
  eliminaDocEvent(event: any) {

    let title = "Eliminazione documento"
    let text = "Sei sicuro di voler eliminare il documento?"
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {title: title, text: text}
    });


    dialogRef.afterClosed().subscribe((result: any) => {
      if (result.confirm) {
        this.api.eliminaDocumento(event.element.idDocumento).subscribe({
          next: (res: any) => {
            if (res.operation != 3) {
              this.loadTable(this.savedEvent);
              this.snackBar.open('Documento eliminato correttamente', 'close', {panelClass: 'successSnack'});
            }
          }
        })
      }
    });


  }

  // EVENTO CLICK INVIA
  inviaEvent(event: any) {

    let title = (this.sectionName == "gestioneProfiloProfessionale") ? "Invia proposta" : "Invia competenza";
    let text = (this.sectionName == "gestioneProfiloProfessionale") ? "Inviare la proposta di profilo professionale ad un tecnico?" : "Inviare la competenza ad un tecnico?";
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {title: title, text: text}
    });

    dialogRef.afterClosed().subscribe((result: any) => {


      if (result.confirm) {
        if (event.element.idProfilo) {
          this.api.sendProfilo(event.element.idProposta).subscribe({
            next: (res: any) => {

              if (res.operation == 2) {
                this.loadTable(this.savedEvent);
                this.snackBar.open('Profilo inviato con successo', 'close', {panelClass: 'successSnack'});
              }


            }
          })
        } else {
          this.api.sendCompetenza(event.element.id).subscribe({
            next: (res: any) => {

              if (res.operation == 2) {
                this.loadTable(this.savedEvent);
                this.snackBar.open('Competenza inviata con successo', 'close', {panelClass: 'successSnack'});
              }
            }
          })
        }
      }
    })
  }

  // EVENTI ASSEMBLEA
  associazioneProfiliAssembleaEvent(event: any) {

    this.api.getProfiliAssegnati(event.element.id).subscribe({

      next: (response: any) => {
        this.detailsData = response.result;
        if (this.detailsData) {


          this.openDialogAssociazioniAssemblea(this.detailsData, 'PROFILI PROFESSIONALI ASSOCIATI');
        }
      }
    })
  }

  associazioneCompetenzeAssembleaEvent(event: any) {

    this.api.getCompetenzeAssegnateAssemblea(event.element.id).subscribe({
      next: (response: any) => {
        this.detailsData = response.result;
        if (this.detailsData) {


          this.openDialogAssociazioniAssemblea(this.detailsData, 'COMPETENZE ASSOCIATE');
        }
      }
    })
  }


  decretaAssembleaEvent(event: any) {
    this.api.getAssemblea(event.element.id).subscribe({
      next: (response: any) => {
        this.detailsData = response.result;
        if (this.detailsData) {
          this.openDialog('edit_decreto')
        }
      }
    })
  }

  pubblicaAssembleaEvent(event: any) {
    const dialogRef = this.dialog.open(AssembleaDecretazioneDialog, {
      data: event,
      height: '95%',
      width: '100%'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadTable(this.savedEvent);

    })
  }

  cancellaAssembleaEvent(event: any) {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {title: "Cancella assemblea", text: "Vuoi cancellare l'assemblea?"}
    });


    dialogRef.afterClosed().subscribe((result: any) => {


      if (result.confirm) {

        this.api.cancellaAssemblea(event.element.id).subscribe({
          next: (response: any) => {

            if (response.operation != 3) {
              this.loadTable(this.savedEvent);
              this.snackBar.open('Assemblea cancellata correttamente', 'close', {panelClass: 'successSnack'});
            }
          }
        })
      }
    })
  }

  approvaContenutiEvent(event: any) {
    const dialogRef = this.dialog.open(AssembleaApprovazioneDialog, {
      data: event,
      height: '95%',
      width: '100%'
    });


    dialogRef.afterClosed().subscribe(() => {
      this.loadTable(this.savedEvent);

    })
  }

  downloadDocumento(file: any) {
    let data = {
      valore: file.element.idDocumento
    }
    this.api.downloadDocumento(data).subscribe(
      response => {
        const contentDisposition = response.headers.get('Content-Disposition');
        let fileName: string = "Documento.pdf";
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match && match.length > 1) {
            fileName = match[1];
          }
        }
        this.api.downloadService(response.body, fileName);
      }
    )
  }

  iconEvent(event: any) {
    switch (event.type) {
      case "dettaglio": {
        this.detailEvent(event);
        break;
      }

      case "dettaglioCompetenza": {
        this.detailCompetenzaEvent(event);
        break;
      }

      case "modificaCompetenza": {
        this.modificaCompetenzaEvent(event);
        break;
      }

      case "validaCompetenza": {
        this.validaCompetenzaEvent(event);
        break;
      }

      case "rifiutaCompetenza": {
        this.rifiutaCompetenzaEvent(event);
        break;
      }

      case "dettaglioProfilo": {
        this.detailProfiloEvent(event);
        break;
      }

      case "validaProfilo": {
        this.validaProfiloEvent(event);
        break;
      }

      case "rifiutaProfilo": {
        this.rifiutaProfiloEvent(event);
        break;
      }

      case "disabilitaUtente": {
        this.disabilitaUtenteEvent(event);
        break;
      }

      case "abilitaUtente": {
        this.abilitaUtenteEvent(event);
        break;
      }

      case "abilitaOperatore": {
        this.abilitaOperatoreEvent(event);
        break;
      }

      case "disabilitaOperatore": {
        this.disabilitaOperatoreEvent(event);
        break;
      }


      case "archiviaCompetenza": {
        this.archiviaCompetenzaEvent(event);
        break;
      }

      case "archiviaProposta": {
        this.archiviaPropostaEvent(event);
        break;
      }

      case "duplicaProfilo": {
        this.duplicaProfiloEvent(event);
        break;
      }

      case "competenze": {
        this.competenzeEvent(event);
        break;
      }

      case "conoscenze": {
        this.conoscenzeEvent(event);
        break;
      }

      case "abilita": {
        this.abilitaEvent(event);
        break;
      }

      case "classificazioni": {
        this.classificazioniEvent(event);
        break;
      }

      case "elimina": {
        this.eliminaEvent(event);
        break;
      }

      case "invia": {
        this.inviaEvent(event);
        break;
      }

      case "decretaAssemblea": {
        this.decretaAssembleaEvent(event);
        break;
      }

      case "pubblicaAssemblea": {
        this.pubblicaAssembleaEvent(event);
        break;
      }

      case "associazioneProfiliAssemblea": {
        this.associazioneProfiliAssembleaEvent(event);
        break;
      }

      case "editAssociazioneProfiliAssemblea": {
        this.editAssociazioneProfiliAssembleaEvent(event);
        break;
      }

      case "associazioneCompetenzeAssemblea": {
        this.associazioneCompetenzeAssembleaEvent(event);
        break;
      }

      case "editAssociazioneCompetenzeAssemblea": {
        this.competenzeAssembleaEvent(event);
        break;
      }

      case "eliminaAssemblea": {
        this.cancellaAssembleaEvent(event);
        break;
      }

      case "approvaContenuti": {
        this.approvaContenutiEvent(event);
        break;
      }

      case "detailAbilitaConoscenze": {
        this.detailAbilitaConoscenze(event);
        break;
      }
      case "sostituisciDoc": {
        this.sostituisciDoc(event);
        break;
      }
      case "eliminaDoc": {
        this.eliminaDocEvent(event);
        break;
      }
      case "scaricaDocPdf": {
        this.downloadDocumento(event);
        break;
      }

      case 'duplicaCompetenza': {
        this.duplicaCompetenza(event);
        break;
      }
      case 'dettaglioArea': {
        this.openDettaglioAreaDialog(event);
        break;
      }
      case 'modificaArea': {
        this.openDettaglioAreaDialog(event, true);
        break;
      }

      default: {
        break;
      }

    }

  }

  duplicaCompetenza(event: any){
    this.api.duplicaCompetenzaDecretata(event.element.id)
      .subscribe({
        next: (response: {messaggio: string, result: BooleanoView}) => {
          if(response.result){
            this.snackBar.open(response.messaggio, 'close', {panelClass: 'successSnack'});
          }
        }
      })
  }


  newEvent(event: any) {
    if (!event?.id) {
      this.openDialog(event);
    } else {

      this.detailsData = {
        descrizione: '',
        dtCaricamento: '',
        idDocumento: null,
        idAreaCaricamento: event.id,
        idAllegato: null,
        posizione: null
      };
      if (this.detailsData) {
        this.openDialogNewCaricaDocumenti()
      }
    }

  }


  // assemblea open dialog

  openDialogAssociazioniAssemblea(data: any, type: string) {
    const dialogRef = this.dialog.open(ListaAssociazioniDialog, {
      data: {lista: data, tipo: type},
      height: '95%',
      width: '100%'
    });

    dialogRef.componentInstance.onAssociazioneClick.subscribe((response) => {


      if (response.idProposta) {
        this.api.getProfiloDettaglio(response.idProposta).subscribe({
          next: (res: any) => {
            this.openDettaglioPropostaProfiloProfessionaleDialog(res.result, this.hasPermission)
          }
        })
      } else {
        this.api.getCompetenzaDettaglio(response.id).subscribe({
          next: (res: any) => {
            this.openDettaglioPropostaDialog(res.result, this.hasPermission)
          }
        })
      }
    });
  }


  openDettaglioAbilitaConoscenze(competenza: any, event: any) {
    this.dialog.open(DetailsAbilitaConoscenzeDialog, {
      minHeight: '25%',
      minWidth: '50%',
      data: {competenza, event}
    });
  }

  openModificaPropostaDialog(competenza: any, permessi: boolean) {
    const dialogRef = this.dialog.open(ModificaPropostaCompetenzaDialog, {
      data: {competenza: competenza, permessi: permessi},
      height: '95%',
      width: '100%',
      panelClass: 'modifica-proposta-competenza-dialog'
    });

    dialogRef.afterClosed().subscribe(() => {
        this.loadTable(this.savedEvent);
    });

  }

  openDettaglioPropostaDialog(competenza: any, permessi: boolean) {
    this.dialog.open(DetailsPropostaCompetenzaDialog, {
      data: {competenza: competenza, permessi: permessi},
      height: '95%',
      width: '100%'
    });
  }

  openDettaglioAreaDialog(area: any, modifica: boolean = false) {
    this.api.getAssociazioniArea(area.element.id).subscribe({
      next: (response: any) => {
          area.element.numeroAssociazioni = response.result;
          const dialogRef = this.dialog.open(DetailsAreaDialog, {
            data: {area: area.element, modifica: modifica},
            height: '65%',
            width: '50%'
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result && this.savedEvent) {
              this.loadTable(this.savedEvent);
            }
          });
      }
    });
  }

  openDettaglioPropostaProfiloProfessionaleDialog(profilo: any, permessi: boolean) {
    const dialogRef = this.dialog.open(DetailsPropostaProfiloProfessionaleDialog, {
      data: {profilo: profilo, permessi: permessi},
      height: '95%',
      width: '100%',
      panelClass: 'details-proposta-profilo-professionale-dialog'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.loadTable(this.savedEvent);
      }
    });
  }

  openClassificazioniDialog(data: any) {
    data['permission'] = this.hasPermission;
    this.dialog.open(ClassificazioniDialog, {
      data: data,
      height: '115%',
      width: '100%'

    });
  }

  openAssociaCompetenzeDialog(competenze: any, lista: any, idProposta: any, count: any, area: string, profilo: string, tipoAssociazione: string): void {

    const dialogRef = this.dialog.open(AssociazioniDialog, {
      data: {
        associate: competenze,
        lista: lista,
        count: count,
        area: area,
        profilo: profilo,
        permission: this.hasPermission,
        tipo: tipoAssociazione,
        isAssemblea: this.sectionName,
        idProposta: idProposta
      },
      height: '95%',
      width: '80%'
    });
    dialogRef.componentInstance.onSaveClick.subscribe((result) => {
      let data = result.associate;
      let tipo = (this.sectionName == 'gestioneAssemblea') ? 'assemblea' : tipoAssociazione;

      switch (tipo) {
        case 'competenze': {
          this.api.associaCompetenze(data, idProposta).subscribe({
            next: (response: any) => {
              const successMsg = response.messaggio && response.messaggio.length > 0
                ? response.messaggio[0]
                : COMPETENCES_ASSOCIATED_SUCCESSFULLY;
              this.snackBar.open(successMsg, 'close', {panelClass: 'successSnack'});
            },
            error: () => {
              this.snackBar.open('Errore di connessione con il server', 'close', {panelClass: 'errorSnack'});
            }
          });
          break;
        }

        case 'assemblea': {
          if (tipoAssociazione == 'competenze') {
            this.api.associaCompetenzeAssemblea(data, idProposta).subscribe({
              next: () => {
                this.snackBar.open(COMPETENCES_ASSOCIATED_SUCCESSFULLY, 'close', {panelClass: 'successSnack'});
              }
            })
          } else {
            this.api.associaProfiliAssemblea(data, idProposta).subscribe({
              next: () => {
                this.snackBar.open('Profili associati con successo', 'close', {panelClass: 'successSnack'});
              }
            })
          }

          break;
        }

        case 'conoscenze': {
          this.api.associaConoscenza(data, idProposta).subscribe({
            next: () => {
              this.snackBar.open('Conoscenze associate con successo', 'close', {panelClass: 'successSnack'});
            }
          })
          break;
        }

        case 'abilita': {
          this.api.associaAbilita(data, idProposta).subscribe({
            next: () => {
              this.snackBar.open('Abilità associate con successo', 'close', {panelClass: 'successSnack'});
            }
          })
          break;
        }
      }
    })
       
    dialogRef.componentInstance.onAddClick.subscribe((configs) => {
      if (configs.type === 'new' && configs.isProfilo) {
    
        forkJoin({
          tipologie: this.api.getTipologiaCompetenza(),
          aree: this.api.getTAreaProfiloAttivo(),
          catBase: this.api.getTipologiaCategoriaBase(),
          catDigitale: this.api.getTipologiaCategoriaDigitale(),
        }).subscribe({
          next: (res: any) => {
            if (configs.overrideSearchBoxData[0]) {
              configs.overrideSearchBoxData[0].options = res.tipologie.result;
            }
            if (configs.overrideSearchBoxData[1]) {
              res.aree.result.sort((a: any, b: any) => (a.id < b.id ? -1 : 1));
              configs.overrideSearchBoxData[1].options = res.aree.result;
            }
            if (configs.overrideSearchBoxData[2]) {
              configs.overrideSearchBoxData[2].options = res.catBase.result;
            }
            if (configs.overrideSearchBoxData[4]) {
              configs.overrideSearchBoxData[4].options = res.catDigitale.result;
            }
          },
          error: (err: Error) => {
            console.error('Errore nel caricamento delle liste:', err);
            this.snackBar.open(
              'Errore nel caricamento dei dati necessari',
              'close',
              { panelClass: 'errorSnack' }
            );
          },
        });
        const targetSection: string = configs.sectionName; 
        configs.overrideSearchBoxData = searchboxdata.list.filter((el: any) => el.id === 2 || el.id === 5)[0].data;
        this.newEvent({ ...configs, targetSection, mode: 'new' });
      } else if (configs.type == 'conoscenze' || configs.type == 'abilita') {
        this.dialog.open(ConoscenzeAbilitaDialog, {
          data: {type: configs.type, id: configs.id},
          height: '95%',
          width: '80%'
        });
      } else {
        this.api.getCompetenzaDettaglio(configs.id).subscribe({
          next: (res: any) => {
            this.openDettaglioPropostaDialog(res.result, this.hasPermission)
          }
        })
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        let data = result.associate;
        let tipo = (this.sectionName == 'gestioneAssemblea') ? 'assemblea' : tipoAssociazione;

        switch (tipo) {
          case 'competenze': {
            this.api.associaCompetenze(data, idProposta).subscribe({
              next: () => {
                this.snackBar.open(COMPETENCES_ASSOCIATED_SUCCESSFULLY, 'close', {panelClass: 'successSnack'});
              }
            })
            break;
          }

          case 'assemblea': {
            if (tipoAssociazione == 'competenze') {
              this.api.associaCompetenzeAssemblea(data, idProposta).subscribe({
                next: () => {
                  this.snackBar.open(COMPETENCES_ASSOCIATED_SUCCESSFULLY, 'close', {panelClass: 'successSnack'});
                }
              })
            } else {
              this.api.associaProfiliAssemblea(data, idProposta).subscribe({
                next: () => {
                  this.snackBar.open('Profili associati con successo', 'close', {panelClass: 'successSnack'});
                }
              })
            }

            break;
          }

          case 'conoscenze': {
            this.api.associaConoscenza(data, idProposta).subscribe({
              next: () => {
                this.snackBar.open('Conoscenze associate con successo', 'close', {panelClass: 'successSnack'});
              }
            })
            break;
          }

          case 'abilita': {
            this.api.associaAbilita(data, idProposta).subscribe({
              next: () => {
                this.snackBar.open('Abilità associate con successo', 'close', {panelClass: 'successSnack'});
              }
            })
            break;
          }
        }

      }
    });
  }

  openDialog(type: any): void {
    if (type == 'new' || type?.type === 'new') {
      if (this.sectionName !== "gestioneProfiloProfessionale" && type.type === 'new') {
        this.boxSearchData = type.overrideSearchBoxData;
        this.profiloAttivo(1);
        this.tipologiaCompetenza(0);
      }
      if (this.sectionName == 'gestioneProfiloProfessionale') {
        this.detailsData =
          {
            "nomeProfilo": "",
            "descrizioneArea": {
              "id": null,
              "descrizione": "",
              "ordinamento": null
            },
            "descrizioneProfilo": "",
            "elementiContesto": "",
            "livelloEqf": undefined,
            "motivazioniProposta": ""
          }


      }

      if (this.sectionName == 'gestioneAree') {
        const dialogRef = this.dialog.open(DetailsAreaDialog, {
          data: {
            area: {
              "id": null,
              "descrizione": "",
              "statoArea": {
                "id": 1,
                "descrizione": "BOZZA"
              },
              "ordinamento": null,
            }, creazione: true
          },
          height: '45%',
          width: '50%'
        });
        dialogRef.afterClosed().subscribe((result: any) => {
          if (result && this.savedEvent) {
            this.loadTable(this.savedEvent);
          }
        });
        return;
      }

      if (this.sectionName == 'gestioneCompetenze') {
        this.detailsData =
          {
            "tipologia": {
              "id": null,
              "descrizione": "",
              "ordinamento": null
            },
            "tipoArea": {
              "id": null,
              "descrizione": "",
              "ordinamento": null
            },
            "descrizione": "",
            "informazioniCompetenza": "",
            "eqfCompetenza": null
          }
      }

      if (this.sectionName == 'gestioneAssemblea') {
        this.detailsData =
          {
            "id": null,
            "dataRiunione": null,
            "dataApprovazione": null,
            "descrizione": null,
            "stato": {
              "id": null,
              "descrizione": null,
              "ordinamento": null
            },
            "dataDecreto": null,
            "nomeDecreto": null,
            "idDocumentoDecreto": null
          }
      }

      if (this.sectionName == 'gestioneUtenze') {
        this.detailsData =
          {
            "idUtente": null,
            "cognomeUtente": null,
            "codiceFiscale": null,
            "nomeUtente": null,
            "flagAttivo": null,
            "dataRegistrazione": null,
            "dataNascita": null,
            "sesso": null,
            "codFiscValid": null,
            "idPersona": null,
            "listaRuoli": [],
            "operatore": {
              "id": null,
              "descrizione": null,
              "ordinamento": null
            },
            "listaTelefoni": [],
            "listaFax": [],
            "listaEmail": [],
            "idOperatore": null
          }
      }


      if (this.sectionName == 'gestioneOperatori') {
        this.detailsData =
          {
            "id": null,
            "descrizione": null,
            "indirizzo": null,
            "cap": null,
            "flagAttivo": null,
            "comune": null,
            "cmbProvincia": {
              "id": null,
              "descrizione": null,
              "ordinamento": null
            },
            "cmbComune": {
              "id": null,
              "descrizione": null,
              "ordinamento": null
            },
            "listaProvince": [],
            "listaComuni": [],
            "listaSedi": [],
            "bModifica": null,
            "tipoOperatore": {
              "id": null,
              "descrizione": null
            }
          }
      }

    }

    if (type == 'conoscenze') {
      this.detailsData =
        {

          "descrizione": ""
        }
    }

    if (type == 'abilita') {
      this.detailsData =
        {

          "descrizione": ""
        }
    }

    if (type == 'new_competenze') {
      this.detailsData =
        {
          "tipologia": {
            "id": null,
            "descrizione": "",
            "ordinamento": null
          },
          "tipoArea": {
            "id": null,
            "descrizione": "",
            "ordinamento": null
          },
          "descrizione": "",
          "informazioniCompetenza": "",
          "eqfCompetenza": null
        }
    }


    let section: string;
    section = (type == 'new_competenze') ? 'gestioneCompetenze' : this.sectionName;
    if (type.targetSection) {
      section = type.targetSection; 
    }
    if (type == 'new_competenze') {
      this.tipologiaCompetenza(0);
      this.profiloAttivo(1);
    }

    if (type == "edit_decreto") {
      this.hasPermission = true;
    }

    if (type == 'new' || type?.type === 'new') {
      if (this.detailsData?.dataRiunione) {
        this.detailsData.dataRiunione = null;
      }

      if (this.detailsData?.dataApprovazione) {
        this.detailsData.dataApprovazione = null;
      }

      if (this.detailsData?.dataDecreto) {
        this.detailsData.dataDecreto = null;
      }
    }

    const selectData = type?.type === 'new' ? type.overrideSearchBoxData : this.boxSearchData;
    const dialogRef = this.dialog.open(DetailsDialog, {
      data: {
        details: this.detailsData,
        permission: this.hasPermission,
        selectData,
        sectionName: section,
        type: type.type ?? type,
        isProfilo: type.isProfilo,
        descrizioneCompetenza: type.descrizioneCompetenza
      },
      height: '95%',
      width: '100%'
    });

    dialogRef.componentInstance.onAddClick.subscribe((response) => {
      this.openSede();
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (section == 'gestioneProfiloProfessionale') {
        this.profiloAttivo(0);
      }
      if (result) {
        // PROFILO PROFESSIONALE
        if (section == 'gestioneProfiloProfessionale') {
          this.api.saveProfilo(result.details).subscribe({
            next: () => {
              this.loadTable(this.savedEvent);
              this.snackBar.open('Profilo salvato', 'close', {panelClass: 'successSnack'});
            }
          })
        }
        // DUPLICAZIONE PROFILO PROFESSIONALE
        if (type == 'duplica_profilo') {


          this.api.saveDuplicaProfilo(result.details, result.details.idProposta).subscribe({
            next: () => {
              this.loadTable(this.savedEvent);
              this.snackBar.open('Profilo salvato', 'close', {panelClass: 'successSnack'});
            }
          })
        }
        // COMPETENZE
        if (section == 'gestioneCompetenze') {
          this.api.salvaCompetenza(result.details).subscribe({
            next: () => {
              this.loadTable(this.savedEvent);
              this.snackBar.open('Competenza salvata', 'close', {panelClass: 'successSnack'});
            }
          })
        }

        // CONOSCENZE

        if (section == 'conoscenze') {


          this.api.saveConoscenza(result.details).subscribe({
            next: () => {
              this.loadTable(this.savedEvent);
              this.snackBar.open('Conoscenza salvata', 'close', {panelClass: 'successSnack'});
            }
          })
        }

        // ABILITA'

        if (section == 'abilita') {


          this.api.saveAbilita(result.details).subscribe({
            next: () => {
              this.loadTable(this.savedEvent);
              this.snackBar.open('Abilita salvata', 'close', {panelClass: 'successSnack'});
            }
          })
        }


        // UTENZE
        if (section == 'gestioneUtenze') {
          this.api.salvaUtenza(result.details).subscribe({
            next: (response: any) => {
              if (response.result.booleano) {
                this.loadTable(this.savedEvent);
                this.snackBar.open('Utenza salvata', 'close', {panelClass: 'successSnack'});
              } else {
                const errorMsg = response.messaggio && response.messaggio.length > 0
                  ? response.messaggio[0]
                  : 'Errore nel salvataggio dell\'utenza';
                this.snackBar.open(errorMsg, 'close', {panelClass: 'errorSnack'});
              }
            },
            error: () => {
              this.snackBar.open('Errore di connessione con il server', 'close', {panelClass: 'errorSnack'});
            }
          });

        }

        // ASSEMBLEA
        if (section == 'gestioneAssemblea') {
          let day = result.details.dataRiunione.getDate();
          day = (day < 10) ? "0" + day : day;
          let month = result.details.dataRiunione.getMonth() + 1;
          month = (month < 10) ? "0" + month : month;
          let year = result.details.dataRiunione.getFullYear();
          result.details['dataRiunione'] = year + '-' + month + '-' + day;

          day = result.details.dataApprovazione.getDate();
          day = (day < 10) ? "0" + day : day;
          month = result.details.dataApprovazione.getMonth() + 1;
          month = (month < 10) ? "0" + month : month;
          year = result.details.dataApprovazione.getFullYear();
          result.details['dataApprovazione'] = year + '-' + month + '-' + day;

          if (result.type != 'new') {
            day = result.details.dataDecreto.getDate();
            day = (day < 10) ? "0" + day : day;
            month = result.details.dataDecreto.getMonth() + 1;
            month = (month < 10) ? "0" + month : month;
            year = result.details.dataDecreto.getFullYear();
            result.details['dataDecreto'] = year + '-' + month + '-' + day;

            this.api.salvaAssembleaDecreto(result.details).subscribe({
              next: () => {
                this.loadTable({...this.savedEvent, isSearch: true});
                this.snackBar.open('Assemblea salvata', 'close', {panelClass: 'successSnack'});
              }
            })
          } else {
            this.api.salvaAssemblea(result.details).subscribe({
              next: () => {
                this.loadTable({...this.savedEvent, isSearch: true});
                this.snackBar.open('Assemblea salvata', 'close', {panelClass: 'successSnack'});
              }
            })
          }
        }

        // OPERATORI
        if (section == 'gestioneOperatori') {
          this.api.saveOperatore(result.details).subscribe({
            next: () => {
              this.loadTable(this.savedEvent);
              this.snackBar.open('Operatore salvato', 'close', {panelClass: 'successSnack'});
            }
          })
        }
      }
    });
  }

  openSede(): void {
    const dialogRef = this.dialog.open(SediDialog, {
      data: {},
      height: '95%',
      width: '100%'
    });

    dialogRef.afterClosed().subscribe((result: any) => {


      if (result) {


        this.detailsData.listaSedi.push(result);
      }
    });
  }


}
